<template>
  <div class="min-h-screen bg-gray-50 p-4">
    <div class="max-w-md mx-auto">
      <h1 class="text-2xl font-bold text-center mb-8">溯源测试页面</h1>
      
      <div class="bg-white rounded-lg shadow-md p-6">
        <h2 class="text-lg font-semibold mb-4">测试溯源链接</h2>
        
        <div class="space-y-4">
          <router-link 
            to="/trace/TEST1"
            class="block w-full p-4 bg-blue-600 text-white text-center rounded-lg hover:bg-blue-700 transition-colors"
          >
            查看测试溯源信息 (TEST1)
          </router-link>
          
          <router-link 
            to="/trace/ABC12"
            class="block w-full p-4 bg-green-600 text-white text-center rounded-lg hover:bg-green-700 transition-colors"
          >
            查看测试溯源信息 (ABC12)
          </router-link>
        </div>
        
        <div class="mt-6 p-4 bg-gray-100 rounded-lg">
          <h3 class="font-semibold mb-2">说明：</h3>
          <ul class="text-sm text-gray-600 space-y-1">
            <li>• 点击上方按钮测试溯源页面</li>
            <li>• 开发模式下会使用示例数据</li>
            <li>• 生产环境需要配置真实的API</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Test page component
</script>